// Module
var code = "<h1 class=\"header__logo homage uppercase\">Cultura Partenopea</h1> <div class=\"header__marquee bc-red uppercase inter\"></div> ";
// Exports
export default code;